import React, { useEffect, useState, } from "react";
import axios from "../../../utills/api";

import {
    Button,
    Card,
    CardBody,
    Col,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Badge,
    Container
} from "reactstrap";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
const TaxiServices = () => {
    document.title = "HMS | Manage Taxi";
    /* =====================================
       STATE
    ===================================== */

    const [services, setServices] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [fetchLoading, setFetchLoading] =
        useState(true);

    const [modalOpen, setModalOpen] =
        useState(false);


    const initialFormData = {

        cabType: "",

        cabCategory: "",

        cabBrand: "",

        cabModel: "",

        cabName: "",

        fuelType: "",

        acType: "",

        seatingCapacity: "",

        luggageCapacity: "",

        image: "",

        description: "",

        inclusions: [],

        status: "active",

    };


    const [formData, setFormData] =
        useState(initialFormData);


    const [inclusion, setInclusion] =
        useState({

            title: "",

            description: "",

            icon: "",

        });


    /* =====================================
       FETCH TAXI SERVICES
    ===================================== */

    const fetchServices = async () => {

        try {

            setFetchLoading(true);


            const response =
                await axios.get(
                    "/taxi-services"
                );


            setServices(
                response.data?.data || []
            );


        } catch (error) {

            console.error(
                "Failed to fetch taxi services",
                error
            );


            setServices([]);


        } finally {

            setFetchLoading(false);

        }

    };


    useEffect(() => {

        fetchServices();

    }, []);



    /* =====================================
       OPEN ADD MODAL
    ===================================== */

    const openAddModal = () => {

        setFormData(
            initialFormData
        );


        setInclusion({

            title: "",

            description: "",

            icon: "",

        });


        setModalOpen(true);

    };



    /* =====================================
       CLOSE MODAL
    ===================================== */

    const closeModal = () => {

        if (loading) return;

        setModalOpen(false);

    };



    /* =====================================
       FORM CHANGE
    ===================================== */

    const handleChange = (
        e
    ) => {

        const {
            name,
            value,
        } = e.target;


        setFormData(
            (prev) => ({

                ...prev,

                [name]: value,

            })
        );

    };



    /* =====================================
       ADD INCLUSION
    ===================================== */

    const addInclusion = () => {

        if (
            !inclusion.title.trim()
        ) {

            alert(
                "Please enter inclusion title"
            );

            return;

        }


        setFormData(
            (prev) => ({

                ...prev,

                inclusions: [

                    ...prev.inclusions,

                    {
                        title:
                            inclusion.title,

                        description:
                            inclusion.description,

                        icon:
                            inclusion.icon,
                    },

                ],

            })
        );


        setInclusion({

            title: "",

            description: "",

            icon: "",

        });

    };



    /* =====================================
       REMOVE INCLUSION
    ===================================== */

    const removeInclusion = (
        index
    ) => {

        setFormData(
            (prev) => ({

                ...prev,

                inclusions:
                    prev.inclusions.filter(
                        (_, i) =>
                            i !== index
                    ),

            })
        );

    };



    /* =====================================
       SUBMIT TAXI SERVICE
    ===================================== */

    const handleSubmit = async (
        e
    ) => {

        e.preventDefault();

        setLoading(true);


        try {

            await axios.post(

                "/taxi-services",

                {

                    ...formData,

                    seatingCapacity:
                        Number(
                            formData.seatingCapacity
                        ),

                    luggageCapacity:
                        Number(
                            formData.luggageCapacity || 0
                        ),

                }

            );


            alert(
                "Taxi service created successfully"
            );


            setModalOpen(false);


            setFormData(
                initialFormData
            );


            setInclusion({

                title: "",

                description: "",

                icon: "",

            });


            await fetchServices();


        } catch (error) {

            console.error(
                "Create Taxi Service Error:",
                error
            );


            alert(

                error.response?.data?.message ||

                "Failed to create taxi service"

            );


        } finally {

            setLoading(false);

        }

    };



    /* =====================================
       DELETE TAXI
    ===================================== */

    const handleDelete = async (
        id
    ) => {

        const confirmed =
            window.confirm(
                "Are you sure you want to delete this taxi?"
            );


        if (!confirmed) return;


        try {

            await axios.delete(
                `/taxi-services/${id}`
            );


            setServices(
                (prev) =>
                    prev.filter(
                        (item) =>
                            item._id !== id
                    )
            );


        } catch (error) {

            console.error(
                "Delete Taxi Error:",
                error
            );


            alert(
                "Failed to delete taxi service"
            );

        }

    };



    /* =====================================
       DEFAULT CAB IMAGE
    ===================================== */

    const defaultCabImage =
        "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&w=900&q=80";



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Manage Taxi" pageTitle="Taxi" />
                    <Row>
                        <Card>
                            <CardBody>
                                {/* =================================
            PAGE HEADER
        ================================= */}

                                <div
                                    className="
            d-flex
            align-items-center
            justify-content-between
            mb-4
          "
                                >

                                    <div>

                                        <h4 className="mb-1">

                                            Taxi Services

                                        </h4>


                                        <p className="text-muted mb-0">

                                            Manage your available taxi and cab services

                                        </p>

                                    </div>


                                    <Button
                                        color="primary"
                                        onClick={
                                            openAddModal
                                        }
                                    >

                                        <i className="ri-add-line me-1"></i>

                                        Add Car

                                    </Button>

                                </div>



                                {/* =================================
            LOADING
        ================================= */}

                                {fetchLoading ? (

                                    <div
                                        className="
              text-center
              py-5
              text-muted
            "
                                    >

                                        Loading taxi services...

                                    </div>

                                ) : services.length === 0 ? (

                                    /* =================================
                                       EMPTY STATE
                                    ================================= */

                                    <Card
                                        className="
              border-0
              shadow-sm
            "
                                    >

                                        <CardBody
                                            className="
                text-center
                py-5
              "
                                        >

                                            <div
                                                className="
                  mb-3
                  text-muted
                "
                                            >

                                                <i
                                                    className="
                    ri-taxi-line
                    display-4
                  "
                                                ></i>

                                            </div>


                                            <h5>

                                                No Taxi Services Found

                                            </h5>


                                            <p
                                                className="
                  text-muted
                  mb-3
                "
                                            >

                                                Add your first cab service to get started.

                                            </p>


                                            <Button
                                                color="primary"
                                                onClick={
                                                    openAddModal
                                                }
                                            >

                                                <i className="ri-add-line me-1"></i>

                                                Add First Car

                                            </Button>

                                        </CardBody>

                                    </Card>

                                ) : (

                                    /* =================================
                                       TAXI CARDS
                                    ================================= */

                                    <Row>

                                        {services.map(
                                            (service) => (

                                                <Col
                                                    xl={3}
                                                    lg={4}
                                                    md={6}
                                                    sm={12}
                                                    key={service._id}
                                                    className="mb-4"
                                                >

                                                    <Card
                                                        className="
                      h-100
                      border
                      shadow-sm
                    "
                                                    >


                                                        {/* =========================
                        CAB IMAGE
                    ========================== */}

                                                        <div
                                                            style={{

                                                                height: "190px",

                                                                overflow: "hidden",

                                                                position: "relative",

                                                                background:
                                                                    "#f5f5f5",

                                                            }}
                                                        >

                                                            <img

                                                                src={
                                                                    service.image ||
                                                                    defaultCabImage
                                                                }

                                                                alt={
                                                                    service.cabName
                                                                }

                                                                onError={(e) => {

                                                                    e.currentTarget.src =
                                                                        defaultCabImage;

                                                                }}

                                                                style={{

                                                                    width: "100%",

                                                                    height: "100%",

                                                                    objectFit: "cover",

                                                                }}

                                                            />


                                                            {/* STATUS */}

                                                            <div
                                                                style={{

                                                                    position: "absolute",

                                                                    top: "12px",

                                                                    right: "12px",

                                                                }}
                                                            >

                                                                <Badge
                                                                    color={
                                                                        service.status ===
                                                                            "active"
                                                                            ? "success"
                                                                            : "danger"
                                                                    }
                                                                >

                                                                    {
                                                                        service.status ===
                                                                            "active"
                                                                            ? "Active"
                                                                            : "Inactive"
                                                                    }

                                                                </Badge>

                                                            </div>

                                                        </div>



                                                        <CardBody>


                                                            {/* =========================
                          CAB NAME
                      ========================== */}

                                                            <div
                                                                className="
                          d-flex
                          justify-content-between
                          align-items-start
                        "
                                                            >

                                                                <div>

                                                                    <h5
                                                                        className="mb-1
      fw-semibold
                            "
                                                                    >

                                                                        {
                                                                            service.cabName
                                                                        }

                                                                    </h5>


                                                                    <p
                                                                        className="
                              text-muted
                              mb-3
                              small
                            "
                                                                    >

                                                                        {
                                                                            service.cabBrand
                                                                        }

                                                                        {" • "}

                                                                        {
                                                                            service.cabModel
                                                                        }

                                                                    </p>

                                                                </div>


                                                                <div
                                                                    className="
                            dropdown
                          "
                                                                >

                                                                    <button
                                                                        className="
                              btn
                              btn-sm
                              btn-light
                            "
                                                                        type="button"
                                                                    >

                                                                        <i className="ri-more-2-fill"></i>

                                                                    </button>

                                                                </div>

                                                            </div>



                                                            {/* =========================
                          CAB DETAILS
                      ========================== */}

                                                            <Row
                                                                className="g-2"
                                                            >

                                                                <Col xs={6}>

                                                                    <div
                                                                        className="
                              border
                              rounded
                              p-2
                            "
                                                                    >

                                                                        <small
                                                                            className="
                                text-muted
                                d-block
                              "
                                                                        >

                                                                            Type

                                                                        </small>


                                                                        <span
                                                                            className="fw-medium"
                                                                        >

                                                                            {
                                                                                service.cabType
                                                                            }

                                                                        </span>

                                                                    </div>

                                                                </Col>


                                                                <Col xs={6}>

                                                                    <div
                                                                        className="
                              border
                              rounded
                              p-2
                            "
                                                                    >

                                                                        <small
                                                                            className="
                                text-muted
                                d-block
                              "
                                                                        >

                                                                            Fuel

                                                                        </small>


                                                                        <span
                                                                            className="fw-medium"
                                                                        >

                                                                            {
                                                                                service.fuelType
                                                                            }

                                                                        </span>

                                                                    </div>

                                                                </Col>


                                                                <Col xs={6}>

                                                                    <div
                                                                        className="
                              border
                              rounded
                              p-2
                            "
                                                                    >

                                                                        <small
                                                                            className="
                                text-muted
                                d-block
                              "
                                                                        >

                                                                            Air Conditioning

                                                                        </small>


                                                                        <span
                                                                            className="fw-medium"
                                                                        >

                                                                            {
                                                                                service.acType
                                                                            }

                                                                        </span>

                                                                    </div>

                                                                </Col>


                                                                <Col xs={6}>

                                                                    <div
                                                                        className="
                              border
                              rounded
                              p-2
                            "
                                                                    >

                                                                        <small
                                                                            className="
                                text-muted
                                d-block
                              "
                                                                        >

                                                                            Seats

                                                                        </small>


                                                                        <span
                                                                            className="fw-medium"
                                                                        >

                                                                            <i className="ri-user-line me-1"></i>

                                                                            {
                                                                                service.seatingCapacity
                                                                            }

                                                                        </span>

                                                                    </div>

                                                                </Col>

                                                            </Row>



                                                            {/* =========================
                          DESCRIPTION
                      ========================== */}

                                                            {service.description && (

                                                                <p
                                                                    className="
                            text-muted
                            small
                            mt-3
                            mb-2
                          "
                                                                >

                                                                    {
                                                                        service.description
                                                                    }

                                                                </p>

                                                            )}



                                                            {/* =========================
                          INCLUSIONS
                      ========================== */}

                                                            {service.inclusions?.length > 0 && (

                                                                <div
                                                                    className="mt-3"
                                                                >

                                                                    <small
                                                                        className="
                              text-muted
                              fw-semibold
                            "
                                                                    >

                                                                        INCLUSIONS

                                                                    </small>


                                                                    <div
                                                                        className="
                              mt-2
                            "
                                                                    >

                                                                        {service.inclusions
                                                                            .slice(0, 3)
                                                                            .map(
                                                                                (
                                                                                    item,
                                                                                    index
                                                                                ) => (

                                                                                    <div
                                                                                        key={index}
                                                                                        className="
                                      d-flex
                                      align-items-center
                                      mb-1
                                    "
                                                                                    >

                                                                                        <i
                                                                                            className="
                                        ri-checkbox-circle-line
                                        text-success
                                        me-2
                                      "
                                                                                        ></i>


                                                                                        <small>

                                                                                            {
                                                                                                item.title
                                                                                            }

                                                                                        </small>

                                                                                    </div>

                                                                                )
                                                                            )}


                                                                        {service.inclusions.length > 3 && (

                                                                            <small
                                                                                className="
                                  text-primary
                                "
                                                                            >

                                                                                +
                                                                                {
                                                                                    service.inclusions.length - 3
                                                                                }
                                                                                {" more inclusions"}

                                                                            </small>

                                                                        )}

                                                                    </div>

                                                                </div>

                                                            )}



                                                            {/* =========================
                          ACTION BUTTONS
                      ========================== */}

                                                            <div
                                                                className="
                          d-flex
                          gap-2
                          mt-4
                        "
                                                            >

                                                                <Button
                                                                    outline
                                                                    color="primary"
                                                                    size="sm"
                                                                    className="w-100"
                                                                >

                                                                    <i className="ri-edit-line me-1"></i>

                                                                    Edit

                                                                </Button>


                                                                <Button
                                                                    outline
                                                                    color="danger"
                                                                    size="sm"
                                                                    onClick={() =>
                                                                        handleDelete(
                                                                            service._id
                                                                        )
                                                                    }
                                                                >

                                                                    <i className="ri-delete-bin-line"></i>

                                                                </Button>

                                                            </div>


                                                        </CardBody>

                                                    </Card>

                                                </Col>

                                            )
                                        )}

                                    </Row>

                                )}



                                {/* =================================
            ADD TAXI MODAL
        ================================= */}

                                <Modal
                                    isOpen={modalOpen}
                                    toggle={closeModal}
                                    size="lg"
                                    centered
                                    scrollable
                                >


                                    <ModalHeader
                                        toggle={closeModal}
                                    >

                                        Add Taxi Service

                                    </ModalHeader>



                                    <ModalBody>


                                        <form
                                            onSubmit={handleSubmit}
                                        >


                                            {/* =============================
                  BASIC DETAILS
              ============================== */}

                                            <h6
                                                className="
                  text-primary
                  mb-3
                "
                                            >

                                                Cab Information

                                            </h6>


                                            <Row>


                                                {/* CAB TYPE */}

                                                <Col
                                                    md={6}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Cab Type

                                                    </Label>


                                                    <Input
                                                        type="select"
                                                        name="cabType"
                                                        value={
                                                            formData.cabType
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                        required
                                                    >

                                                        <option value="">

                                                            Select Cab Type

                                                        </option>

                                                        <option value="Hatchback">

                                                            Hatchback

                                                        </option>

                                                        <option value="Sedan">

                                                            Sedan

                                                        </option>

                                                        <option value="SUV">

                                                            SUV

                                                        </option>

                                                        <option value="MUV">

                                                            MUV

                                                        </option>

                                                        <option value="Luxury">

                                                            Luxury

                                                        </option>

                                                        <option value="Tempo Traveller">

                                                            Tempo Traveller

                                                        </option>

                                                    </Input>

                                                </Col>



                                                {/* CAB BRAND */}

                                                <Col
                                                    md={6}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Cab Brand

                                                    </Label>


                                                    <Input
                                                        name="cabBrand"
                                                        placeholder="Example: Toyota"
                                                        value={
                                                            formData.cabBrand
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                        required
                                                    />

                                                </Col>



                                                {/* CAB MODEL */}

                                                <Col
                                                    md={6}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Cab Model

                                                    </Label>


                                                    <Input
                                                        name="cabModel"
                                                        placeholder="Example: Innova Crysta"
                                                        value={
                                                            formData.cabModel
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                        required
                                                    />

                                                </Col>



                                                {/* CAB NAME */}

                                                <Col
                                                    md={6}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Display Name

                                                    </Label>


                                                    <Input
                                                        name="cabName"
                                                        placeholder="Example: Toyota Innova Crysta"
                                                        value={
                                                            formData.cabName
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                        required
                                                    />

                                                </Col>



                                                {/* FUEL TYPE */}

                                                <Col
                                                    md={6}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Fuel Type

                                                    </Label>


                                                    <Input
                                                        type="select"
                                                        name="fuelType"
                                                        value={
                                                            formData.fuelType
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                        required
                                                    >

                                                        <option value="">

                                                            Select Fuel Type

                                                        </option>

                                                        <option value="Petrol">

                                                            Petrol

                                                        </option>

                                                        <option value="Diesel">

                                                            Diesel

                                                        </option>

                                                        <option value="CNG">

                                                            CNG

                                                        </option>

                                                        <option value="Electric">

                                                            Electric

                                                        </option>

                                                        <option value="Hybrid">

                                                            Hybrid

                                                        </option>

                                                    </Input>

                                                </Col>



                                                {/* AC TYPE */}

                                                <Col
                                                    md={6}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Air Conditioning

                                                    </Label>


                                                    <Input
                                                        type="select"
                                                        name="acType"
                                                        value={
                                                            formData.acType
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                        required
                                                    >

                                                        <option value="">

                                                            Select Option

                                                        </option>

                                                        <option value="AC">

                                                            AC

                                                        </option>

                                                        <option value="Non-AC">

                                                            Non-AC

                                                        </option>

                                                    </Input>

                                                </Col>



                                                {/* SEATING */}

                                                <Col
                                                    md={6}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Seating Capacity

                                                    </Label>


                                                    <Input
                                                        type="number"
                                                        min="1"
                                                        name="seatingCapacity"
                                                        placeholder="Example: 6"
                                                        value={
                                                            formData.seatingCapacity
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                        required
                                                    />

                                                </Col>



                                                {/* LUGGAGE */}

                                                <Col
                                                    md={6}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Luggage Capacity

                                                    </Label>


                                                    <Input
                                                        type="number"
                                                        min="0"
                                                        name="luggageCapacity"
                                                        placeholder="Example: 3 bags"
                                                        value={
                                                            formData.luggageCapacity
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                    />

                                                </Col>



                                                {/* IMAGE */}

                                                <Col
                                                    md={12}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Cab Image URL

                                                    </Label>


                                                    <Input
                                                        name="image"
                                                        placeholder="https://example.com/car.jpg"
                                                        value={
                                                            formData.image
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                    />

                                                </Col>



                                                {/* DESCRIPTION */}

                                                <Col
                                                    md={12}
                                                    className="mb-3"
                                                >

                                                    <Label>

                                                        Description

                                                    </Label>


                                                    <Input
                                                        type="textarea"
                                                        name="description"
                                                        rows="3"
                                                        placeholder="Enter a short description about this cab..."
                                                        value={
                                                            formData.description
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                    />

                                                </Col>

                                            </Row>



                                            <hr className="my-4" />



                                            {/* =============================
                  INCLUSIONS
              ============================== */}

                                            <div
                                                className="
                  d-flex
                  justify-content-between
                  align-items-center
                  mb-3
                "
                                            >

                                                <div>

                                                    <h6
                                                        className="
                      text-primary
                      mb-0
                    "
                                                    >

                                                        Inclusions

                                                    </h6>


                                                    <small
                                                        className="
                      text-muted
                    "
                                                    >

                                                        Add what is included in the taxi service

                                                    </small>

                                                </div>

                                            </div>



                                            <Row
                                                className="mb-3"
                                            >

                                                <Col md={5}>

                                                    <Label>

                                                        Inclusion Title

                                                    </Label>


                                                    <Input
                                                        placeholder="Example: 157 Km included"
                                                        value={
                                                            inclusion.title
                                                        }
                                                        onChange={(e) =>

                                                            setInclusion(
                                                                (prev) => ({

                                                                    ...prev,

                                                                    title:
                                                                        e.target.value,

                                                                })
                                                            )

                                                        }
                                                    />

                                                </Col>



                                                <Col md={5}>

                                                    <Label>

                                                        Description

                                                    </Label>


                                                    <Input
                                                        placeholder="Example: ₹16/km beyond included kms"
                                                        value={
                                                            inclusion.description
                                                        }
                                                        onChange={(e) =>

                                                            setInclusion(
                                                                (prev) => ({

                                                                    ...prev,

                                                                    description:
                                                                        e.target.value,

                                                                })
                                                            )

                                                        }
                                                    />

                                                </Col>



                                                <Col
                                                    md={2}
                                                    className="
                    d-flex
                    align-items-end
                  "
                                                >

                                                    <Button
                                                        type="button"
                                                        color="primary"
                                                        className="w-100"
                                                        onClick={
                                                            addInclusion
                                                        }
                                                    >

                                                        <i className="ri-add-line"></i>

                                                    </Button>

                                                </Col>

                                            </Row>



                                            {/* =============================
                  INCLUSION LIST
              ============================== */}

                                            {formData.inclusions.length > 0 && (

                                                <div
                                                    className="mb-4"
                                                >

                                                    {formData.inclusions.map(
                                                        (
                                                            item,
                                                            index
                                                        ) => (

                                                            <div
                                                                key={index}
                                                                className="
                          border
                          rounded
                          p-3
                          mb-2
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                                                            >

                                                                <div>

                                                                    <div
                                                                        className="
                              fw-semibold
                            "
                                                                    >

                                                                        <i
                                                                            className="
                                ri-checkbox-circle-line
                                text-success
                                me-2
                              "
                                                                        ></i>

                                                                        {
                                                                            item.title
                                                                        }

                                                                    </div>


                                                                    {item.description && (

                                                                        <small
                                                                            className="
                                text-muted
                                ms-4
                              "
                                                                        >

                                                                            {
                                                                                item.description
                                                                            }

                                                                        </small>

                                                                    )}

                                                                </div>


                                                                <Button
                                                                    color="danger"
                                                                    outline
                                                                    size="sm"
                                                                    type="button"
                                                                    onClick={() =>
                                                                        removeInclusion(
                                                                            index
                                                                        )
                                                                    }
                                                                >

                                                                    <i className="ri-delete-bin-line"></i>

                                                                </Button>

                                                            </div>

                                                        )
                                                    )}

                                                </div>

                                            )}



                                            {/* =============================
                  STATUS
              ============================== */}

                                            <Row>

                                                <Col md={6}>

                                                    <Label>

                                                        Status

                                                    </Label>


                                                    <Input
                                                        type="select"
                                                        name="status"
                                                        value={
                                                            formData.status
                                                        }
                                                        onChange={
                                                            handleChange
                                                        }
                                                    >

                                                        <option value="active">

                                                            Active

                                                        </option>

                                                        <option value="inactive">

                                                            Inactive

                                                        </option>

                                                    </Input>

                                                </Col>

                                            </Row>



                                            {/* =============================
                  MODAL BUTTONS
              ============================== */}

                                            <div
                                                className="
                  d-flex
                  justify-content-end
                  gap-2
                  mt-4
                  pt-3
                  border-top
                "
                                            >

                                                <Button
                                                    type="button"
                                                    color="light"
                                                    onClick={
                                                        closeModal
                                                    }
                                                    disabled={
                                                        loading
                                                    }
                                                >

                                                    Cancel

                                                </Button>


                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    disabled={
                                                        loading
                                                    }
                                                >

                                                    {loading ? (

                                                        <>
                                                            Saving...
                                                        </>

                                                    ) : (

                                                        <>
                                                            <i className="ri-save-line me-1"></i>

                                                            Save Car
                                                        </>

                                                    )}

                                                </Button>

                                            </div>


                                        </form>


                                    </ModalBody>


                                </Modal>


                            

                        </CardBody>
                    </Card>
                </Row>
            </Container>
        </div>
     </React.Fragment >

  

  );

};


export default TaxiServices;